export default "__VITE_ASSET__Hv$uQMG5__"